import styled from 'styled-components';

const SocialLinksStyled = styled.div`
    display: flex;
    align-items: center;
`;

export default SocialLinksStyled;